import { VertesiaClient } from "@vertesia/client"
import { ContentObjectItem } from "@vertesia/common"
import { toast } from "sonner"

import { RENDITION_ID } from "@constants/cookies"
import { RENDITION_OPTIONS } from "@constants/renditions"

import { isImage, isPdf, isVideo } from "@lib/mime"

export async function retrieveRendition(client: VertesiaClient, doc: ContentObjectItem, setRenditionUrl: (url: string) => void, setRenditionAlt: (alt: string) => void) {
    if (!doc?.content?.type || !(isImage(doc.content.type) || isVideo(doc.content.type) || isPdf(doc.content.type))) {
        return
    }

    const currentTime = new Date().getTime() / 1000

    const savedId = localStorage.getItem(`${RENDITION_ID}_${doc.id}_${RENDITION_OPTIONS.max_hw}`)
    const elapsedTime = localStorage.getItem(`${RENDITION_ID}_${doc.id}_${RENDITION_OPTIONS.max_hw}_time`)

    if (savedId?.length && elapsedTime && Math.abs(currentTime - parseInt(elapsedTime)) <= 900) {
        setRenditionUrl(savedId)
        setRenditionAlt(`${doc.name} Rendition`)
        return savedId
    }

    client.objects.getRendition(doc.id, RENDITION_OPTIONS).then((response) => {
        if (response.status === "generating") {
            setTimeout(retrieveRendition, 60000)
        } else if (response.status === "failed") {
            toast.error("Rendition generation Error", {
                description: "Failed to generate Rendition for background removal",
                duration: 4000,
            })
        } else {
            if (!response.renditions || !response.renditions.length) {
                toast.error("Rendition generation Error", {
                    description: "Rendition Source is Missing",
                    duration: 4000,
                })
                return
            }

            setRenditionUrl(response.renditions[0])
            setRenditionAlt(`${doc.name} Rendition`)
        }
    })
}

export async function retrieveRenditionById(client: VertesiaClient, id: string, setRenditionUrl: (url: string) => void, setRenditionAlt: (alt: string) => void) {
    const currentTime = new Date().getTime() / 1000

    const savedId = localStorage.getItem(`${RENDITION_ID}_${id}_${RENDITION_OPTIONS.max_hw}`)
    const elapsedTime = localStorage.getItem(`${RENDITION_ID}_${id}_${RENDITION_OPTIONS.max_hw}_time`)
    if (savedId?.length && elapsedTime && Math.abs(currentTime - parseInt(elapsedTime)) <= 900) {
        setRenditionUrl(savedId)
        setRenditionAlt(`${id} Rendition`)
        return savedId
    }

    client.objects.getRendition(id, RENDITION_OPTIONS).then((response) => {
        if (response.status === "generating") {
            setTimeout(retrieveRendition, 60000)
        } else if (response.status === "failed") {
            toast.error("Rendition generation Error", {
                description: "Failed to generate Rendition for background removal",
                duration: 4000,
            })
        } else {
            if (!response.renditions || !response.renditions.length) {
                toast.error("Rendition generation Error", {
                    description: "Rendition Source is Missing",
                    duration: 4000,
                })
                return
            }

            setRenditionUrl(response.renditions[0])
            setRenditionAlt(`${id} Rendition`)
        }
    })
}
